import { Box, Skeleton, useMediaQuery } from '@mui/material';

export const SkeletonLinkPreview = ({ isOwnMessage }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        mt: 1,
        border: '1px solid #ddd',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        width: isMobile ? '65vw' : '300px',
        marginBottom: 2,
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <Skeleton variant="rectangular" width={300} height={150} />
      <Box sx={{ padding: '8px' }}>
        <Skeleton variant="text" width="80%" />
        <Skeleton variant="text" width="60%" sx={{ mt: 0.5 }} />
      </Box>
    </Box>
  );
};
